import moment, { Moment } from 'moment';
import 'moment/locale/pt-br';
import $ from 'jquery';
import 'print-this';
import {
  format,
  subYears,
  differenceInCalendarYears,
  getHours,
  getMinutes,
  isValid,
  getYear,
  getMonth,
  getDay,
  getSeconds,
} from 'date-fns';
import uuid from 'uuid/v4';
import TagManager from 'react-gtm-module';

import pt from 'date-fns/locale/pt';
import { cloneDeep } from 'lodash';
import { images } from 'assets/images/import-images';
import { ITypePurchase } from 'models/checkout/IFormCheckout';
import { MONTHS, WEEKDAYS_LONG, IS_CORDOVA, AMBIENTE_ATUAL } from '../constants/constants';

moment.locale('pt-br');
const defaultMomentFormat = 'YYYY-MM-DDTHH:mm:ss';

type TypeProduct =
  | 'hotel-aereo'
  | 'hotel-aereo-carro'
  | 'hotel-carro'
  | 'hotel'
  | 'carro'
  | 'aereo'
  | 'seguro';

declare global {
  interface Window {
    MSStream: any;
  }
}

export class Utils {
  static retornaSomenteNumero(str: string): string {
    if (!str) return undefined;
    return str.replace(/[^\d]+/g, '');
  }

  static isMobileWindow(): boolean {
    const dispositivo = window.innerWidth;
    const isMobile = dispositivo < 768;
    return isMobile;
  }

  static converteEmMoeda = (
    n: any,
    c?: number,
    d?: unknown,
    t?: unknown,
  ): string => {
    c = Math.abs(c);
    // eslint-disable-next-line
    c = isNaN(c) ? 2 : c;
    d = d === undefined ? ',' : d;
    t = t === undefined ? '.' : t;
    const s = n < 0 ? '-' : '';
    const i = `${parseInt((n = Math.abs(+n || 0).toFixed(c)), 10)}`;
    let j = i.length;
    j = j > 3 ? j % 3 : 0;
    return (
      s +
      (j ? i.substr(0, j) + t : '') +
      i.substr(j).replace(/(\d{3})(?=\d)/g, `$1${t}`) +
      (c
        ? d +
          Math.abs(n - Number(i))
            .toFixed(c)
            .slice(2)
        : '')
    );
  };

  static moedaParaNumero(valor: any): number {
    // eslint-disable-next-line
    return isNaN(valor) === false
      ? parseFloat(valor)
      : parseFloat(valor.replace('R$', '').replace('.', '').replace(',', '.'));
  }

  static retornaDiaEMesEAnoAdt(): string {
    return format(this.retornaDataNascimentoAdt(), 'yyyy-MM-dd', {
      locale: pt,
    });
  }

  static retornaDataNascimentoAdt(): Date {
    return subYears(Utils.getDate(), 18);
  }

  static retonaDiaEMesEAno(date: Date): string {
    if (!this.isValidDate(date)) {
      return format(this.retornaDataNascimentoAdt(), 'dd/MM/yyyy', {
        locale: pt,
      });
    }
    return Utils.getDiaEMesEAnoFormatado(date);
  }

  static getDiaEMesEAnoFormatado(date: Date | string): string {
    if (date instanceof Date) {
      return moment(date, defaultMomentFormat).format('DD/MM/YYYY');
    }
    
    if (date != null) {
      const [dateFormatted] = date.split('T');
      const [year, month, day] = dateFormatted.split('-');
      return `${day}/${month}/${year}`;
    }

  }

  static getAnoEMesEDiaFormatado(date: Date | string): string {
    if (date instanceof Date) {
      const newDate = moment(date, defaultMomentFormat).format('DD-MM-YYYY');
      return newDate;
    }

    const [dateFormatted] = date.split('T');
    const [year, month, day] = dateFormatted.split('-');
    return `${day}-${month}-${year}`;
  }

  static retonaDiaEMesEAnoExtenso(date: string): string {
    return moment(date, defaultMomentFormat).locale('pt-BR').format('LL');
  }

  static retonaDiaEMesEAnoExtensoSimplificado(date: string): string {
    return moment(date, defaultMomentFormat)
      .locale('pt-BR')
      .format('ddd. D MMM. YYYY');
  }

  static retonaDiaEMesExtensoSimplificado(date: string): string {
    return moment(date, defaultMomentFormat).locale('pt-BR').format('ddd, D MMM');
  }

  static getDayAndMonth(date: string | Date): string {
    return moment(date, defaultMomentFormat).locale('pt-BR').format('D [de] MMMM');
  }

  static getDayAndMonthExtended(date: string | Date): string {
    return moment(date, defaultMomentFormat).locale('pt-BR').format('ddd D MMMM');
  }

  static retonaDiaEMesEAnoSimples(date: Date | string): string {
    return Utils.getAnoEMesEDiaFormatado(date);
  }

  static retonaDiaEMesEAnoContraido(date: Date): string {
    return format(date, "eee'. 'd' 'MMM'. 'yyyy", { locale: pt });
  }

  static menorValor(lista: number[]): number {
    if (lista.length === 0) {
      return null;
    }
    return lista.reduce((a, b) => Math.min(a, b));
  }

  static maiorValor(lista: number[]): number {
    if (lista.length === 0) {
      return null;
    }
    return lista.reduce((a, b) => Math.max(a, b));
  }

  static hideCreditCardNumber(number: string): string {
    const quantityLastDigits = 4;
    number =
      new Array(number.length - quantityLastDigits + 1).join('*') +
      number.slice(-quantityLastDigits);
    let newval = '';
    for (let i = 0; i < number.length; i += 1) {
      if (i % 4 === 0 && i > 0) newval = newval.concat(' ');
      newval = newval.concat(number[i]);
    }
    return newval;
  }

  static getQuantityDays(
    firstDate: Date | string,
    secondDate: Date | string,
  ): number {
    const oneDay = 24 * 60 * 60 * 1000;
    firstDate = Utils.getDate(firstDate);
    secondDate = Utils.getDate(secondDate);
    return Math.round(
      Math.abs((firstDate.getTime() - secondDate.getTime()) / oneDay),
    );
  }

  static getDiffDays(
    firstDate: Date | string | number,
    secondDate: Date | string | number,
  ): number {
    const a = moment(firstDate, defaultMomentFormat);
    const b = moment(secondDate, defaultMomentFormat);
    return a.diff(b, 'days');
  }

  static discount(num: number, per: number): number {
    return num - (num * per) / 100;
  }

  static retirarFormatacao(str: string): string {
    return str.replace(/(\.|\/|-)/g, '');
  }

  static retirarEspacoEmBranco(str: string): string {
    return str.replace(/\s/g, '');
  }

  static mascaraCpf(v: string): string {
    v = v.replace(/\D/g, '');
    v = v.replace(/(\d{3})(\d)/, '$1.$2');
    v = v.replace(/(\d{3})(\d)/, '$1.$2');
    v = v.replace(/(\d{3})(\d{1,2})$/, '$1-$2');

    return v;
  }

  static validateEmail(email: string): boolean {
    const re = /^.*(?=.{8,})[\w.]+@[\w.-]+[.][a-zA-Z0-9]+$/;
    return re.test(email);
  }

  static converterParaDateString(date: any, separator = '/'): Date {
    if (Utils.getDate(date) instanceof Date) return Utils.getDate(date);

    if (date instanceof Date) {
      return date;
    }

    const [day, month, year] = date.split(separator);
    return Utils.getDate(`${year}-${month}-${day}`);
  }

  static arredondarMeiaHoraMais(date: string): Date {
    let data = this.converterStringParaDateCarro(date);
    const minutos = data.getMinutes();
    data =
      minutos <= 30
        ? Utils.getDate(data.getTime() + (30 - minutos) * 60000)
        : Utils.getDate(data.getTime() + (60 - minutos) * 60000);
    return data;
  }

  static arredondarMeiaHoraMenos(date: string): Date {
    let data = this.converterStringParaDateCarro(date);
    const minutos = data.getMinutes();
    data =
      minutos <= 30
        ? Utils.getDate(data.getTime() - minutos * 60000)
        : Utils.getDate(data.getTime() + (30 - minutos) * 60000);
    return data;
  }

  static getDate(data?: string | Date | number): Date {
    if (data instanceof Date || typeof data === 'number') {
      return moment(
        data,
        typeof data !== 'number' ? defaultMomentFormat : null,
      ).toDate();
    }
    if (data) {
      return Utils.converterStringParaDate(data);
    }
    return moment().toDate();
  }

  static getDateInMoment(
    data?: string | Date | number,
    formatData = defaultMomentFormat,
  ): Moment {
    if (data instanceof Date || typeof data === 'number') {
      return moment(data, typeof data !== 'number' ? formatData : null);
    }

    if (data) {
      return moment(data, formatData);
    }

    return moment(moment(), formatData);
  }

  static getMomentDuration(
    inp?: moment.DurationInputArg1,
    unit?: moment.unitOfTime.DurationConstructor,
  ): moment.Duration {
    return moment.duration(inp, unit);
  }

  static converterStringParaDate(data: string | Date): Date {
    if (data instanceof Date) {
      return moment(data, defaultMomentFormat).toDate();
    }
    return moment(data, defaultMomentFormat).toDate();
  }

  static converterStringParaDateCarro(data: string): Date {
    return Utils.getDate(data);
  }

  static converterParaDate(date: string | Date, separator = '/'): Date {
    if (!date) return null;

    if (date instanceof Date) {
      return date;
    }

    const [day, month, year] = date.split(separator);
    return Utils.getDate(`${year}-${month}-${day}`);
  }

  static converterParaDateApi(date: string | Date, separator = '/'): string {
    if (!date) return null;
    if (date instanceof Date) {
      const newDate = moment(date, defaultMomentFormat).format('YYYY-MM-DD');
      return newDate;
    } 

    if (date.includes('T')) {
      const [dateFormatted] = date.split('T');
      const [year, month, day] = dateFormatted.split('-');
      return `${year}-${month}-${day}`;
    }

    const [day, month, year] = date.split(separator);
    return `${year}-${month}-${day}`;
  }

  static somenteNumeros(str: string): string {
    if (str != null) return str.replace(/\D/g, '');
    return null;
  }

  static retonaDiaEMes(date: Date): string {
    return format(Utils.getDate(date), 'DD/MM', { locale: pt });
  }

  static checkDateValidation(valor: string): boolean {
    if (!valor) {
      return false;
    }
    if (valor && valor.length !== 10) {
      return false;
    }

    const date = valor;
    let ardt = [];
    const ExpReg = new RegExp(
      '(0[1-9]|[12][0-9]|3[01])/(0[1-9]|1[012])/[12][0-9]{3}',
    );
    ardt = date.split('/');
    let erro = false;
    const dataAtual = Utils.getDate();
    if (date.search(ExpReg) === -1) {
      erro = true;
    } else if (
      (ardt[1] === 4 || ardt[1] === 6 || ardt[1] === 9 || ardt[1] === 11) &&
      ardt[0] > 30
    ) {
      erro = true;
    } else if (ardt[1] === 2) {
      if (ardt[0] > 28 && ardt[2] % 4 !== 0) {
        erro = true;
      }
      if (ardt[0] > 29 && ardt[2] % 4 === 0) {
        erro = true;
      }
    } else if (ardt[2] > dataAtual.getFullYear) {
      erro = true;
    }
    if (erro) {
      return false;
    }
    return true;
  }

  static validaCPF(cpfSemFormatar: string): boolean {
    if (!cpfSemFormatar) {
      return false;
    }
    const cpf = this.retirarFormatacao(cpfSemFormatar);
    let numeros;
    let digitos;
    let soma;
    let i;
    let resultado;
    let digitosIguais;
    digitosIguais = 1;
    if (cpf.length < 11) {
      return false;
    }
    for (i = 0; i < cpf.length - 1; i += 1) {
      if (cpf.charAt(i) !== cpf.charAt(i + 1)) {
        digitosIguais = 0;
        break;
      }
    }
    if (!digitosIguais) {
      numeros = cpf.substring(0, 9);
      digitos = cpf.substring(9);
      soma = 0;
      for (i = 10; i > 1; i -= 1) {
        soma += numeros.charAt(10 - i) * i;
      }
      resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
      if (resultado !== parseInt(digitos.charAt(0), 10)) {
        return false;
      }
      numeros = cpf.substring(0, 10);
      soma = 0;
      for (i = 11; i > 1; i -= 1) {
        soma += numeros.charAt(11 - i) * i;
      }
      resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
      if (resultado !== parseInt(digitos.charAt(1), 10)) {
        return false;
      }
      return true;
    }
    return false;
  }

  static verificarCartao(numberCard: string): string {
    const number = this.retirarEspacoEmBranco(numberCard);
    let re;
    // Elo
    re = new RegExp(
      '^401178|^401179|^431274|^438935|^451416|^457393|^457631|^457632|^504175|^627780|^636297|^636368|^(506699|5067[0-6]|50677[0-8])|^(50900|5090[1-9]|509[1-9]{2})|^65003[1-3]|^(65003[5-9]|65004|65005[0-1])|^(65040[5-9]|6504[1-3])|^(65048[5-9]|65049|6505[0-2]|65053[0-8])|^(65054[1-9]|6505[5-8]|65059[0-8])|^(65070|65071[0-8])|^65072[0-7]|^(65090[1-9]|65091|650920)|^(65165[2-9]|6516[6-7])|^(65500|65501)|^(65502[1-9]|6550[3-4]|65505[0-8])',
    );
    if (number.match(re) != null) {
      return 'elo';
    }
    // visa
    re = new RegExp('^4');
    if (number.match(re) != null) {
      return 'visa';
    }
    // Mastercard
    re = new RegExp('^(5[1-5]|2[2-7])');
    if (number.match(re) != null) {
      return 'mastercard';
    }
    // AMEX
    re = new RegExp('^3[47]');
    if (number.match(re) != null) {
      return 'amex';
    }
    // Diners
    re = new RegExp('^3(?:0[0-5]|[68][0-9])');
    if (number.match(re) != null) {
      return 'diners';
    }
    // Hipercard - Carte Blanche
    re = new RegExp('^3841[046]0|^60');
    if (number.match(re) != null) {
      return 'hipercard';
    }
    return null;
  }

  static validaTelefone(number: string): boolean {
    if (!number) return null;
    const re =
      /^(?:(?:\+|00)?(55)\s?)?(?:\(?([1-9][0-9])\)?\s?)?(?:((?:9\d|[2-9])\d{3})-?(\d{4}))$/;
    return re.test(Utils.somenteNumeros(number));
  }

  static validaMascaraTelefone(number: string): string {
    return number && number.length <= 14 ? '(99) 9999-99999' : '(99) 99999-9999';
  }

  static getValorParcelas(precoTotal: number, numeroParcelas: number): string {
    const valorParcela = Number(Number(precoTotal / numeroParcelas).toFixed(2));
    const valorPrimeiraParcela = (
      precoTotal -
      valorParcela * (numeroParcelas - 1)
    ).toFixed(2);
    if (numeroParcelas === 1) {
      return String(`${numeroParcelas}x R$${valorParcela}`);
    }
    return String(
      `${numeroParcelas}x (1 de R$ ${valorPrimeiraParcela} + ${numeroParcelas - 1
      } de R$${valorParcela})`,
    );
  }

  static mascaraCartao(v: string): string {
    v = v.replace(/\D/g, '');
    v = v.replace(/(\d{4})/g, '$1 ');
    v = v.replace(/\.$/, '');
    v = v.substring(0, 19);
    return v;
  }

  static separaValorEDecimal(v: string): { inteiro: string; decimal: string } {
    const valor = String(v);
    const valorSplit = valor.split('.');
    const inteiro = valorSplit[0];
    let decimal = valorSplit[1];
    if (decimal && decimal.length === 1) {
      decimal += '0';
    }
    decimal = !decimal ? '00' : decimal;

    return {
      inteiro,
      decimal: decimal ? decimal.substring(0, 2) : null,
    };
  }

  static removerAcentos(newStringComAcento: string): string {
    let string = newStringComAcento;
    const mapaAcentosHex = {
      a: /[\xE0-\xE6]/g,
      A: /[\xC0-\xC6]/g,
      e: /[\xE8-\xEB]/g,
      E: /[\xC8-\xCB]/g,
      i: /[\xEC-\xEF]/g,
      I: /[\xCC-\xCF]/g,
      o: /[\xF2-\xF6]/g,
      O: /[\xD2-\xD6]/g,
      u: /[\xF9-\xFC]/g,
      U: /[\xD9-\xDC]/g,
      c: /\xE7/g,
      C: /\xC7/g,
      n: /\xF1/g,
      N: /\xD1/g,
    };

    Object.keys(mapaAcentosHex).forEach(letra => {
      const expressaoRegular = mapaAcentosHex[letra];
      string = string.replace(expressaoRegular, letra);
    });

    return string;
  }

  static returnDiffTime(dtPartida: Date, dtChegada: Date): string {
    const date1 = Utils.getDate(dtPartida);
    const date2 = Utils.getDate(dtChegada);
    const diffMs = date2.getTime() - date1.getTime();
    const diffHrs = Math.floor((diffMs % 86400000) / 3600000);
    const diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000);
    return `${diffHrs}h ${diffMins}m`;
  }

  static formatDateFull(dataSource: Date): string {
    const data = Utils.getDate(dataSource);
    const diaSemana = WEEKDAYS_LONG[data.getDay() % 7];
    const mes = MONTHS[data.getMonth()];
    const ano = data.getFullYear();
    return [
      `${diaSemana.slice(0, 3)},`,
      data.getDate(),
      mes.slice(0, 3).toLowerCase(),
      ano,
    ].join(' ');
  }

  static returnWithoutParentheses(str: string): string {
    const name = str.split(/[()]+/).filter(e => {
      return e;
    });
    return name[0];
  }

  static getAge(birthDate: Date, today = Utils.getDate()): number {
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age -= 1;
    }
    return age;
  }

  static getAgeMoment(birth: Date | string, date = moment()): number {
    let year = date.diff(birth, 'years', false);
    const month = date.diff(birth, 'month', false) / 12 - year;
    if (
      month < 0 ||
      (month === 0 && moment(birth, defaultMomentFormat).isAfter(date))
    ) {
      year -= 1;
    }
    return year;
  }

  static roundDecimals(num: number): number {
    if (!num) {
      return null;
    }
    return Math.round(num * 100) / 100;
  }

  static retonaHora(date: Date): string {
    const data = Utils.getDate(date);

    const newHour = data.getHours();
    let hour = newHour.toString();
    const minutes = data.getMinutes();
    if (newHour.toString().length < 2) {
      hour = `0${newHour}`;
    }
    return `${hour}:${minutes}`;
  }

  static retornaLarguraPagina(): string {
    if (window.innerWidth <= 767) return 'xs';
    if (window.innerWidth >= 768 && window.innerWidth < 992) return 'sm';
    if (window.innerWidth >= 992 && window.innerWidth < 1280) return 'md';
    if (window.innerWidth >= 1280) return 'lg';
    return null;
  }

  static toCamel(o: unknown): unknown {
    const newO = {};
    let newKey;
    let value;
    if (o instanceof Array) {
      return o.map(v => {
        if (typeof v === 'object') {
          v = Utils.toCamel(v);
        }
        return v;
      });
    }
    Object.keys(o).forEach(key => {
      if (Object.prototype.hasOwnProperty.call(o, 'key')) {
        newKey = (key.charAt(0).toLowerCase() + key.slice(1) || key).toString();
        value = o[key];
        if (
          value instanceof Array ||
          (value !== null && value.constructor === Object)
        ) {
          value = Utils.toCamel(value);
        }
        newO[newKey] = value;
      }
    });

    return newO;
  }

  static calculateAge(birthday: string): number {
    const ageDifMs = moment().valueOf() - moment(birthday, 'DD/MM/YYYY').valueOf();
    const ageDate = Utils.getDate(ageDifMs);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  }

  static returnAge(birthday: string): number {
    const ageDifMs =
      moment().valueOf() - moment(birthday, defaultMomentFormat).valueOf();
    const ageDate = Utils.getDate(ageDifMs);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  }

  static returnPlaceSelectForUrl(data: { Nome: string; UF: string }): string {
    return `${data.Nome}-${data.UF}`;
  }

  static returnPlaceSelectForObject(placeSelected: string): {
    Nome: string;
    UF: string;
  } {
    if (!placeSelected) {
      return {
        Nome: '',
        UF: '',
      };
    }

    const params = placeSelected.split('-');
    return {
      Nome: params[0],
      UF: params[1],
    };
  }

  static returnAgeRange(dateStart: string, dateEnd: string): number {
    return differenceInCalendarYears(
      Utils.getDate(dateStart),
      Utils.getDate(dateEnd),
    );
  }

  static returnHoursDifference(start: Date, end: Date): string {
    const startTime = moment(start, defaultMomentFormat);
    const endTime = moment(end, defaultMomentFormat);
    const duration = moment.duration(endTime.diff(startTime));
    return `${(duration.hours() < 10 ? '0' : '') + duration.hours()}:${duration.minutes() < 10 ? '0' : ''
      }${duration.minutes()}`;
  }

  static allTrue(obj: unknown): boolean {
    const keys = Object.keys(obj);
    const values = Object.values(obj);
    for (let i = 0; i < keys.length; i += 1) {
      if (values[i]) return true;
    }
    return false;
  }

  static checkIsTrue(obj: unknown): boolean {
    const keys = Object.keys(obj);
    const values = Object.values(obj);
    for (let i = 0; i < keys.length; i += 1) {
      if (values[i]) return true;
    }
    return false;
  }

  static getValueBetweenParentheses(str: string): string {
    const result = /\(([^)]+)\)/.exec(str);
    return result && result[1] ? result[1] : str;
  }

  static handleBlockPaste(event: Event): boolean {
    event.preventDefault();
    return false;
  }

  static retornaHorario(date: Date): string {
    return format(Utils.getDate(date), 'HH:mm', { locale: pt });
  }

  static montaObjetoMatrix(
    rows: number,
    cols: number,
    defaultValue: string,
  ): string[] {
    const arr = [];
    for (let i = 0; i < rows; i += 1) {
      arr.push([]);
      arr[i].push(new Array(cols));
      for (let j = 0; j < cols; j += 1) {
        arr[i][j] = defaultValue;
      }
    }
    return arr;
  }

  static print(element: Element, options = null): void {
    $(element).printThis(options);
  }

  static titleCase(str: string): string {
    if (!str) return null;
    const splitStr = str.toLowerCase().split(' ');
    for (let i = 0; i < splitStr.length; i += 1) {
      if (splitStr[i].length > 2) {
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
    }
    return splitStr.join(' ');
  }

  static isUndefined(object: unknown): boolean {
    return object === undefined;
  }

  static returnPercent(valorTotal: string, valorDesconto: string): number {
    const desconBase = Number(valorTotal) - Number(valorDesconto);
    const descFinal =
      parseFloat(String(desconBase)) / parseFloat(String(valorTotal));
    const Total = Number(descFinal * 100);
    return Math.floor(Total * 10) / 10;
  }

  static returnPriceDiscount(valorTotal: string, valorDesconto: string): string {
    return Utils.converteEmMoeda(parseFloat(valorTotal) - parseFloat(valorDesconto));
  }

  static removeDuplicates(arr: Array<any>): string[] {
    const result = [];
    const duplicatesIndices = [];

    arr.forEach((current, index) => {
      if (duplicatesIndices.includes(index)) return;

      result.push(current);

      for (
        let comparisonIndex = index + 1;
        comparisonIndex < arr.length;
        comparisonIndex += 1
      ) {
        const comparison = arr[comparisonIndex];
        const currentKeys = Object.keys(current);
        const comparisonKeys = Object.keys(comparison);

        if (currentKeys.length !== comparisonKeys.length) {
          const currentKeysString = currentKeys.sort().join('').toLowerCase();
          const comparisonKeysString = comparisonKeys.sort().join('').toLowerCase();
          if (currentKeysString !== comparisonKeysString) {
            let valuesEqual = true;
            for (let i = 0; i < currentKeys.length; i += 1) {
              const key = currentKeys[i];
              if (current[key] !== comparison[key]) {
                valuesEqual = false;
                break;
              }
            }
            if (valuesEqual) duplicatesIndices.push(comparisonIndex);
          }
        }
      }
    });

    return result;
  }

  static removeDuplicatesBy(keyFn: any, array: any[]): any[] {
    const mySet = new Set();
    return array.filter(x => {
      const key = keyFn(x);
      const isNew = !mySet.has(key);
      if (isNew) mySet.add(key);
      return isNew;
    });
  }

  static isEmpty(obj: unknown): boolean {
    return Object.entries(obj).length === 0 && obj.constructor === Object;
  }

  static getTypeFornecedor(nomeFornecedor: string): number {
    switch (nomeFornecedor) {
      case 'Omnibees':
        return 11;
      case 'Hsystem':
        return 12;
      default:
        return null;
    }
  }

  static textLimiter(text: string, limit: number): string {
    if (text.length > limit) {
      return `${text.slice(0, limit)}...`;
    }
    return text;
  }

  static calculateTimeFlight(hour1: string, hour2: string): string {
    if (hour1 && hour2) {
      const diff = moment(hour2, 'HH:mm').diff(moment(hour1, 'HH:mm'), 'seconds');
      const date = Utils.getDate(0);
      date.setSeconds(diff); // specify value for SECONDS here
      const result = Utils.returnDateToISOString(date).substr(11, 8);
      const [hour, minute] = result.substring(0, 5).split(':');
      return `${hour}h ${minute}m`;
    }
    return null;
  }

  static getTimeTimeFlight(startDate: string, endDate: string): string {
    if (startDate && endDate) {
      const diff = moment(endDate, defaultMomentFormat).diff(
        moment(startDate, defaultMomentFormat),
      );
      const duration = moment.duration(diff);
      return `${duration.hours()}h ${duration.minutes()}m`;
    }
    return null;
  }

  static isObjectEmpty(obj: unknown): boolean {
    if (!obj) return false;
    return Object.keys(obj).length === 0 && obj.constructor === Object;
  }

  static isMobileDevice(): boolean {
    return (
      /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent,
      ) && !window.MSStream
    );
  }

  static groupBy(list: Array<any>, prop: string): unknown {
    return list.reduce((groups, item) => {
      const val = item[prop];
      groups[val] = groups[val] || [];
      groups[val].push(item);
      return groups;
    }, {});
  }

  static calcPriceHotel(apartaments: Array<any>): number {
    return apartaments.reduce((prevVal, elem) => {
      return parseFloat(prevVal) + parseFloat(elem.ValorCusto);
    }, 0);
  }

  static isContentArray(item: Array<any>): boolean {
    return Array.isArray(item) && item.length > 0;
  }

  static isValidDate(date: Date): boolean {
    const newDate = Utils.getDate(date);
    // eslint-disable-next-line
    return newDate instanceof Date && !isNaN(newDate.valueOf());
  }

  static isSafari(): boolean {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  }

  static isIOS(): boolean {
    return /iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  }

  static testImage(url: string, timeoutT?: number): Promise<unknown> {
    return new Promise((resolve, reject) => {
      const timeout = timeoutT || 5000;
      let timer;
      const img = new Image();
      // eslint-disable-next-line no-multi-assign
      img.onerror = img.onabort = () => {
        clearTimeout(timer);
        reject(new Error('error'));
      };
      img.onload = () => {
        clearTimeout(timer);
        resolve('success');
      };
      timer = setTimeout(() => {
        reject(new Error('error'));
      }, timeout);
      img.src = url;
    });
  }

  static getNomeCompanhiaAerea(cia: string): string {
    switch (cia) {
      case 'O6':
        return 'Avianca';
      case 'G3':
        return 'Gol';
      case 'AD':
        return 'Azul';
      case 'JJ':
        return 'Latam';
      case 'LA':
        return 'Latam';
      case 'DL':
        return 'Delta';
      case 'TP':
        return 'TAP Air Portugal';
      case 'UX':
        return 'AIR Europa';
      case 'IB':
        return 'Iberia';
      case 'AA':
        return 'AmericanAirLines';
      case 'AF':
        return 'Air France';
      case 'KL':
        return 'KLM';
      case 'AS':
        return 'Alaska AirLines';
      default:
        return null;
    }
  }

  static getLogoCompanhiaAerea(cia: string): string {
    return images.logoCompanhiasAereas[cia];
  }

  static checkStatusOrder(statusPedido: string): string {
    switch (statusPedido) {
      case 'P':
        return 'Pendente';
      case 'C':
        return 'Confirmadas';
      case 'I':
        return 'Cancelada';
      case 'R':
        return 'Realizadas';

      default:
        return '';
    }
  }

  static checkCodeStatusOrder(statusPedido: string): string {
    switch (statusPedido) {
      case 'pendentes':
        return 'P';
      case 'confirmadas':
        return 'C';
      case 'canceladas':
        return 'I';
      case 'realizadas':
        return 'R';

      default:
        return '';
    }
  }

  static objectCompare(x: unknown, y: unknown): boolean {
    if (x === y) return true;
    // if both x and y are null or undefined and exactly the same

    if (!(x instanceof Object) || !(y instanceof Object)) return false;
    // if they are not strictly equal, they both need to be Objects

    if (x.constructor !== y.constructor) return false;
    // they must have the exact same prototype chain, the closest we can do is
    // test there constructor.

    // eslint-disable-next-line
    for (const p in x) {
      // eslint-disable-next-line
      if (!x.hasOwnProperty(p)) continue;
      // other properties were tested using x.constructor === y.constructor

      // eslint-disable-next-line
      if (!y.hasOwnProperty(p)) return false;
      // allows to compare x[ p ] and y[ p ] when set to undefined

      // eslint-disable-next-line
      if (x[p] === y[p]) continue;
      // if they have the same strict value or identity then they are equal

      if (typeof x[p] !== 'object') return false;
      // Numbers, Strings, Functions, Booleans must be strictly equal

      if (!Utils.objectCompare(x[p], y[p])) return false;
      // Objects and Arrays must be tested recursively
    }

    // eslint-disable-next-line
    for (let p in y) {
      // eslint-disable-next-line
      if (y.hasOwnProperty(p) && !x.hasOwnProperty(p)) return false;
      // allows x[ p ] to be set to undefined
    }
    return true;
  }

  static handleCardBrandToNumber(value: string): number {
    switch (Utils.verificarCartao(value)) {
      case 'amex':
        return 0;
      case 'diners':
        return 1;
      case 'mastercard':
        return 2;
      case 'visa':
        return 3;
      case 'hipercard':
        return 4;
      case 'elo':
        return 5;
      default:
        return null;
    }
  }

  static handleCardBrandToNumberForCar(value: string): number {
    switch (Utils.verificarCartao(value)) {
      case 'mastercard':
        return 0;
      case 'visa':
        return 1;
      case 'amex':
        return 2;
      case 'diners':
        return 3;
      case 'elo':
        return 4;
      case 'hipercard':
        return 5;
      default:
        return null;
    }
  }

  static retornaNome = (str: string): string => {
    return str.split(' ').slice(0, 1).join(' ');
  };

  static retornaSobrenome = (str: string): string => {
    return str.split(' ').slice(1, str.length).join(' ');
  };

  static getProps = (o: any, s: string): any => {
    s = s.replace(/\[(\w+)\]/g, '.$1');
    s = s.replace(/^\./, '');
    const a = s.split('.');
    for (let i = 0, n = a.length; i < n; i += 1) {
      const k = a[i];
      if (k in o) {
        o = o[k];
      } else {
        return null;
      }
    }
    return o;
  };

  static simpleMemoize = (fn: any): unknown => {
    let lastArg;
    let lastResult;
    return arg => {
      if (arg !== lastArg) {
        lastArg = arg;
        lastResult = fn(arg);
      }
      return lastResult;
    };
  };

  static lengthArray = (array: Array<any>): number => {
    let result = 0;
    for (let i = 0; i < array.length; i += 1) {
      if (array[i]) {
        result += 1;
      }
    }
    return result;
  };

  static returnDateTimeToString = (str: string): string => {
    const [date, time] = str.split('T');
    const [day, month, year] = date.split('-');
    return `${year}-${month}-${day} ${time}:00`;
  };

  static returnDateTimeToStringDefault = (str: string): string => {
    const date = moment(str, defaultMomentFormat).format('YYYY-MM-DD HH:mm:ss');
    return date;
  };

  static returnDateToISOString = (date: string | Date): string => {
    return moment(date, defaultMomentFormat).toISOString(true);
  };

  static returnTimeToString = (str: string): string => {
    const [date, time] = str.replace('Z', '').split('T');
    const [year, month, day] = date.split('-');
    return `${day}-${month}-${year}T${time.substring(0, time.length - 3)}`;
  };

  static returnTime = (date: string): string => {
    const dateTime = Utils.getDate(date);
    return `${String(getHours(dateTime)).padStart(2, '0')}:${String(
      getMinutes(dateTime),
    ).padStart(2, '0')}`;
  };

  static returnDateTime = (str: string): Date => {
    const [date, time] = str.split('T');
    const [day, month, year] = date.split('-');
    const dateTime = `${year}-${month}-${day} ${time}:00`;

    return Utils.getDate(dateTime);
  };

  static returnDateToDateText = (date: string | Date): string => {
    return moment(date, defaultMomentFormat).format('DD/MM/YYYY [às] HH:mm');
  };

  static convertDateTimeToString = (date: Date): string => {
    if (!date || !isValid(date)) return null;

    const year = getYear(date);
    const month = `0${getMonth(date) + 1}`.slice(-2);
    const day = `0${getDay(date) - 1}`.slice(-2);
    const hour = `0${getHours(date)}`.slice(-2);
    const minute = `0${getMinutes(date)}`.slice(-2);
    const second = `0${getSeconds(date)}`.slice(-2);

    return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
  };

  static returnDayWithCompletelyDate = (date: string): string => {
    if (!date) return null;
    const dateObject = Utils.getDate(date);
    return Utils.capitalizeWord(
      format(dateObject, "ccc '-' dd/MM/yyyy", { locale: pt }),
    );
  };

  static capitalizeWord = (s: string): string => {
    if (typeof s !== 'string') return '';
    return s.charAt(0).toUpperCase() + s.slice(1);
  };

  static returnAgeType = (s: string): string => {
    switch (s.toLowerCase()) {
      case 'adt':
        return 'Adulto';
      case 'chd':
        return 'Criança';
      case 'inf':
        return 'Bêbe';

      default:
        return null;
    }
  };

  static includeScript(path: string): void {
    const node = document.createElement('script');
    node.setAttribute('src', path);
    document.body.appendChild(node);
  }

  static convertToUrlFormat = (string: string): string => {
    if (!string) return null;
    return string.replace(/\s+/g, '-').toLowerCase();
  };

  static removeWordFromString = (word: string, string: string): string => {
    if (!string) return null;
    return string.replace(word, '');
  };

  static base64toBlob = (base64Data: string, contentType = ''): Blob => {
    const sliceSize = 1024;
    const byteCharacters = atob(base64Data);
    const bytesLength = byteCharacters.length;
    const slicesCount = Math.ceil(bytesLength / sliceSize);
    const byteArrays = new Array(slicesCount);

    for (let sliceIndex = 0; sliceIndex < slicesCount; sliceIndex += 1) {
      const begin = sliceIndex * sliceSize;
      const end = Math.min(begin + sliceSize, bytesLength);

      const bytes = new Array(end - begin);
      for (let offset = begin, i = 0; offset < end; i += 1, offset += 1) {
        bytes[i] = byteCharacters[offset].charCodeAt(0);
      }
      byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type: contentType });
  };

  static getUniqueId = (): string => {
    return uuid();
  };

  static cloneObject = <T>(data: T): T => {
    return cloneDeep(data);
  };

  static getTimeStamp = (data: string): number => {
    if (!data) return null;
    return Utils.getDateInMoment(data).unix();
  };

  static reverseArray = list => {
    const ret = [];
    for (let i = list.length - 1; i >= 0; i -= 1) {
      ret.push(list[i]);
    }
    return ret;
  };

  static isStringEmpty = (str: string): boolean => {
    return !str || str.length === 0;
  };

  static getNameProduct = (type: ITypePurchase): string => {
    switch (type) {
      case 'car':
        return 'aluguel-de-carro';
      case 'flight':
        return 'passagem-aerea';
      case 'hotel':
        return 'hospedagem';
      case 'insurance':
        return 'seguro';
      case 'package':
        return 'pacote-hotel-aereo';
      case 'package-car':
        return 'pacote-hotel-aereo-carro';
      case 'package-hotel-car':
        return 'pacote-hotel-carro';
      default:
        return null;
    }
  };

  static getNumberTypeProduct = (type: TypeProduct): number => {
    switch (type) {
      case 'hotel-aereo':
        return 1;
      case 'hotel-aereo-carro':
        return 2;
      case 'hotel-carro':
        return 3;
      case 'hotel':
        return 4;
      case 'carro':
        return 5;
      case 'aereo':
        return 6;
      case 'seguro':
        return 7;
      default:
        return 0;
    }
  };

  static getFullSiteURL = (pathname: string): string => {
    if (window?.location && !IS_CORDOVA) {
      return `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
    } else if (window?.location && IS_CORDOVA) {
      return `${window.location.protocol}//${window.location.host}${window.location.pathname}#${pathname}`;
    }
    return '';
  };

  static saveTagManager = (eventName: string, data: any) => {
    console.log(eventName, data);
    if (AMBIENTE_ATUAL === "production") {
      const tagManagerArgs = {
        dataLayer: {
          event: eventName,
          ecommerce: data,
          is_mobile: IS_CORDOVA
        },
      };
      TagManager.dataLayer(tagManagerArgs);
    }
  }
}
